import { External } from "components/icons/generated";

import TableCellLink, { TableCellLinkProps } from "./CellLink";

type TableCellBranchProps = TableCellLinkProps;

const TableCellBranch = (props: TableCellBranchProps) => {
  return <TableCellLink variant="primary" target="_blank" endIcon={External} {...props} />;
};

TableCellBranch.displayName = "DS.Table.CellBranch";

export default TableCellBranch;
